/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';
import {
  AdBodyFormSearch,
  AdBodyFormBottom,
  AdBodyFormBottomLeft,
  AdBodyFormBottomRight,
} from '../styles';
import {
  AdBodyForm,
  AdBodyFormUp,
  AdBodyFormIcon,
  AdBodyFormHeader,
} from '../../styles';
import {
  Label,
  TeamLogo,
  PowerInput,
  TextWarning,
  PowerDropdown,
  InputComponent,
} from '../../../../components';
import { Utils } from '../../../../utils/api';
import { ARMcontext } from '../../../../utils/context/context';
import SponsorLogo from '../../../../assets/icons/SponsorLogo.svg';
import { useInputValue } from '../../../../utils/hooks/useInputValue';
import { defaultSponsor, TYPES_INVITATIONS, SPONSOR_SELECTED_DEFAULT } from '../../../../utils/constants/defaultSponsor';

export default ({
  setInvitations,
  element,
  setError,
  index,
  OnClose,
  length,
  validate,
  membershipsYearly,
  membershipsYearlyTotal,
  membershipsYearlyCount,
  changeMembershipsYearly,
  handleToastMessage
}) => {
  const { teamMemo } = useContext(ARMcontext);
  const emailName = useInputValue(element.email, '', 'normal', '', 'email');
  const [team, setTeam] = useState<any>(element.team || []);
  const [sponsor, useSponsor] = useState<any>(element.sponsor || SPONSOR_SELECTED_DEFAULT);
  const [selectedBlock, setSelectedBlock] = useState<any>();
  const [membershipBlock, setMembershipBlock] = useState<any>(element.block);
  const [indexSelectedMembership, setIndexSelectedMembership] = useState<number>(-1);
  const firstName = useInputValue(element.firstName || '');
  const lastName = useInputValue(element.lastName || '');
  const [date] = useState(new Date());
  const UTILS = new Utils();
  const isValidInput = UTILS.GetValidationInputPattern();
  const isBlankInput = UTILS.GetValidationBlankPattern();
  const isValidEmail = UTILS.GetValidationEmailPattern();

  useEffect(() => {
    useSponsor(element.sponsor)
  }, [element.sponsor])

  useEffect(() => {
    setMembershipBlock(membershipsYearly)
  }, [membershipsYearly])

  useEffect(() => {
    if (validate === 0) {
      return infoChange({ firstName: firstName.value });
    }
    if (!Boolean(firstName.value.length) || isBlankInput.test(firstName.value)) {
      firstName.HandleWarning('This field cannot be empty');
      firstName.HandleStatus('error');
      setError(prev => {
        if (Boolean(prev.filter(el => el.index === 1 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, { index: 1, deep: index }];
        }
      });
    } else if (!isValidInput.test(firstName.value)) {
      firstName.HandleWarning('This field does not allow special characters');
      firstName.HandleStatus('error');
      setError(prev => {
        if (Boolean(prev.filter(el => el.index === 1 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, { index: 1, deep: index }];
        }
      });
    } else {
      firstName.HandleWarning('');
      firstName.HandleStatus('normal');
      setError(prev => {
        return prev.filter(el => !(el.index === 1 && el.deep === index));
      });
    }
    infoChange({ firstName: firstName.value });
  }, [validate, firstName.value]);

  useEffect(() => {
    if (validate === 0) {
      return infoChange({ lastName: lastName.value });
    }
    if (!Boolean(lastName.value.length) || isBlankInput.test(lastName.value)) {
      lastName.HandleWarning('This field cannot be empty');
      lastName.HandleStatus('error');
      setError(prev => {
        if (Boolean(prev.filter(el => el.index === 2 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, { index: 2, deep: index }];
        }
      });
    } else if (!isValidInput.test(lastName.value)) {
      lastName.HandleWarning('This field does not allow special characters');
      lastName.HandleStatus('error');
      setError(prev => {
        if (Boolean(prev.filter(el => el.index === 2 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, { index: 2, deep: index }];
        }
      });
    } else {
      lastName.HandleWarning('');
      lastName.HandleStatus('normal');
      setError(prev => {
        return prev.filter(el => !(el.index === 2 && el.deep === index));
      });
    }
    infoChange({ lastName: lastName.value });
  }, [validate, lastName.value]);

  useEffect(() => {
    if (validate === 0) {
      return infoChange({ email: emailName.value });
    }
    if (!Boolean(emailName.value.length)) {
      emailName.HandleWarning('This field cannot be empty');
      emailName.HandleStatus('error');
      setError(prev => {
        if (Boolean(prev.filter(el => el.index === 3 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, { index: 3, deep: index }];
        }
      });
    } else if (!isValidEmail.test(emailName.value)) {
      emailName.HandleWarning('Invalid email');
      emailName.HandleStatus('error');
      setError(prev => {
        if (Boolean(prev.filter(el => el.index === 3 && el.deep === index).length)) {
          return prev;
        } else {
          return [...prev, { index: 3, deep: index }];
        }
      });
    } else {
      emailName.HandleWarning('');
      emailName.HandleStatus('normal');
      setError(prev => {
        return prev.filter(el => !(el.index === 3 && el.deep === index));
      });
    }
    infoChange({ email: emailName.value });
  }, [validate, emailName.value]);

  useEffect(() => {
    if (validate !== 0) {
      if (sponsor.value === TYPES_INVITATIONS.SPONSOR_PLAYER && !selectedBlock) {
        handleToastMessage('Select an option for ' + sponsor.name + ' dropdown on invitation ' + (index + 1), true, 2000, 'error');
        setError(prev => { return [...prev, { index: 6, deep: index }] });
      }
      else {
        setError(prev => {
          return prev.filter(el => !(el.index === 6 && el.deep === index));
        });
      }
    }
  }, [validate]);

  function infoChange({
    team,
    email,
    sponsor,
    position,
    lastName,
    firstName,
  }: {
    email?: string;
    lastName?: string;
    firstName?: string;
    team?: object | any;
    sponsor?: object | any;
    position?: Array<any> | any;
  }) {
    setInvitations(prev => [
      ...prev.map((el, id) => {
        if (id !== index) {
          return el;
        } else {
          if (firstName) {
            el.firstName = firstName;
          }
          if (lastName) {
            el.lastName = lastName;
          }
          if (team) {
            el.team = team;
          }
          if (position) {
            el.position = position;
          }
          if (email) {
            el.email = email;
          }
          if (sponsor) {
            el.sponsor = sponsor;
          }
          if (selectedBlock) {
            el.selectedBlock = selectedBlock;
          }
          if (date) {
            el.date = date;
          }
          return el;
        }
      }),
    ]);
  }

  function ChangeSponsor(selectedOption: any) {
    if (selectedOption.value === TYPES_INVITATIONS.SPONSOR_PLAYER) {
      setMembershipBlock(membershipsYearly)
    }
    if (selectedOption !== sponsor && indexSelectedMembership > -1) {
      let updateArray = [...membershipBlock];
      updateArray[indexSelectedMembership].selected = false;
      changeMembershipsYearly(updateArray);
      setIndexSelectedMembership(-1);
    }
    setSelectedBlock(undefined);
    useSponsor(selectedOption);
    infoChange({ sponsor: selectedOption });
  }

  function ChangeBlock(selectedOption: any) {
    let updateArray = [...membershipBlock];
    let option = selectedOption;
    if (option.name === 'new') {
      option = membershipBlock.find(item => item.unused && !item.selected)
    }
    let index = membershipBlock.indexOf(option);
    if (indexSelectedMembership > -1) {
      updateArray[indexSelectedMembership].selected = false;
    }
    updateArray[index].selected = true;
    changeMembershipsYearly(updateArray);
    setIndexSelectedMembership(index);
    setSelectedBlock(option);
  }

  function AlternateFocus(hook: any): void {
    hook.HandleStatus('normal');
    hook.HandleWarning('');
  }

  function handleCancelBadge(element) {
    const modTeams = [...team.filter(el => element._id !== el._id)];
    setTeam(modTeams);
    infoChange({ team: modTeams });
  }

  function AddTeam(selectedTeam: any): void {
    setTeam(prev => {
      if (Boolean(prev.filter(el => el.badge === 'ALL').length)) {
        const modTeams = [...prev];
        infoChange({ team: modTeams });
        return modTeams;
      } else if (Boolean(prev.length) && selectedTeam.badge === 'ALL') {
        const modTeams = [...prev];
        infoChange({ team: modTeams });
        return modTeams;
      } else if (!Boolean(prev.filter(el => selectedTeam._id === el._id).length)) {
        const modTeams = [...prev, selectedTeam];
        infoChange({ team: modTeams });
        return modTeams;
      } else {
        const modTeams = [...prev];
        infoChange({ team: modTeams });
        return modTeams;
      }
    });
  }

  function liberateMembership() {
    if (indexSelectedMembership > -1) {
      let updateArray = [...membershipBlock];
      updateArray[indexSelectedMembership].selected = false;
      changeMembershipsYearly(updateArray);
    }
  }

  function parseDateYearlyMembership(date: string) {
    let nDate = new Date(date);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[nDate.getMonth()] + " " + nDate.getUTCDate() + "-" + String(nDate.getFullYear()).substring(2, 4);
  }

  const [,...newTeamMemo] = teamMemo
  return (
    <AdBodyForm data-cy="addPlayers-form-one">
      {length > 1 ? (
        <AdBodyFormHeader>
          <AdBodyFormIcon onClick={() => { liberateMembership(); OnClose(element.id) }} />
        </AdBodyFormHeader>
      ) : (
        <></>
      )}
      <AdBodyFormUp>
        <div style={{ width: '200px', marginRight: '10px' }}>
          <Label text="FIRST NAME" fontWeight="600" fontSize="12px" />
          <InputComponent
            animateWidth="100%"
            dynamicSearch={firstName}
            idKey="1"
            name="firstName"
            HandleFocus={() => AlternateFocus(firstName)}
            maxLength={20}
          />
          <TextWarning status={firstName.status} message={firstName.warningMessage} display="block" />
        </div>
        <div style={{ width: '200px', marginRight: '10px' }}>
          <Label text="LAST NAME" fontWeight="600" fontSize="12px" />
          <InputComponent
            dynamicSearch={lastName}
            animateWidth="100%"
            idKey="2"
            name="lastName"
            HandleFocus={() => AlternateFocus(lastName)}
            maxLength={20}
          />
          <TextWarning status={lastName.status} message={lastName.warningMessage} display="block" />
        </div>
        <div style={{ width: '410px' }}>
          <Label text="EMAIL" fontWeight="600" fontSize="12px" />
          <InputComponent
            dynamicSearch={emailName}
            animateWidth="100%"
            idKey="3"
            name="emailName"
            HandleFocus={() => AlternateFocus(emailName)}
          />
          <TextWarning status={emailName.status} message={emailName.warningMessage} display="block" />
        </div>
      </AdBodyFormUp>
      <AdBodyFormSearch>
        <Label text="TEAM" fontWeight="600" fontSize="12px" />
        <PowerInput maxWidth="100%" search={true} onClick={AddTeam} dataArray={newTeamMemo} selectedTeams={team} handleCancel={handleCancelBadge} />
      </AdBodyFormSearch>
      <AdBodyFormBottom>
        <AdBodyFormBottomLeft>
          <TeamLogo src={SponsorLogo} mTop="10px" link="" />
        </AdBodyFormBottomLeft>
        <AdBodyFormBottomRight>
          <PowerDropdown
            mHeigth="132px"
            onClick={ChangeSponsor}
            search={false}
            dataArray={defaultSponsor}
            primaryTitle={sponsor.name}
            mPadding="4px 0 4px 10px"
            theme="gray"
            membershipCount={{ yearly: membershipsYearlyTotal, selected: 0 }}
          />
          {sponsor.value === TYPES_INVITATIONS.SPONSOR_PLAYER && (
            <div style={{ height: '45px', minWidth: '305px' }}>
              <PowerDropdown
                search={false}
                mHeigth="132px"
                firstActve={true}
                onClick={ChangeBlock}
                dataArray={membershipBlock}
                primaryTitle={selectedBlock ? (!selectedBlock.unused ?
                  `${selectedBlock?.remainingPeriod} Remaining | EXP: ${parseDateYearlyMembership(selectedBlock?.endDate)}` :
                  `Enrolled`) : 'Select option'}
                mPadding="4px 0 4px 10px"
                membershipInfo={{ name: sponsor.value, count: membershipsYearlyCount }}
              />
            </div>
          )}
        </AdBodyFormBottomRight>
      </AdBodyFormBottom>
    </AdBodyForm>
  );
};